<div fxLayout="row" fxLayoutAlign="end center">
  <spx-spinner *ngIf="(cartItemPrice$ | async)?.isPending" [size]="'INLINE'"></spx-spinner>
  <ng-container *ngIf="(cartItemPrice$ | async)?.data">
    <a [routerLink]="['/contact']" *ngIf="(cartItemPrice$ | async)?.data?.PriceI18NCode; else price">{{
      'SHARED.PRICE_I18N_CODE.' + (cartItemPrice$ | async)?.data?.PriceI18NCode | translate
    }}</a>
    <ng-template #price>
      <ng-container [ngSwitch]="priceType">
        <ng-container *ngSwitchCase="'ListPriceEach'">
          {{ (cartItemPrice$ | async)?.data?.ListPriceEach | number: '1.2-2' }} {{ (cartItemPrice$ | async)?.data?.ListPriceCurrency }}
        </ng-container>
        <ng-container *ngSwitchCase="'NetPriceEach'">
          {{ (cartItemPrice$ | async)?.data?.NetPriceEach | number: '1.2-2' }} {{ (cartItemPrice$ | async)?.data?.NetPriceCurrency }}
        </ng-container>
        <ng-container *ngSwitchCase="'NetPriceTotal'">
          {{ (cartItemPrice$ | async)?.data?.NetPriceTotal | number: '1.2-2' }} {{ (cartItemPrice$ | async)?.data?.NetPriceCurrency }}
        </ng-container>
        <ng-container *ngSwitchDefault>Implement a new price total</ng-container>
      </ng-container>
    </ng-template>
  </ng-container>
</div>
